import React from 'react';
import parse from 'html-react-parser';


const Consent = ({ consent }) => {

  return (
    <div className='text-field input-field' style={{ order: 1 }}>
      <label className="input-label">Terms and Conditions</label>
      <div className='consent mt-3'>
        {/* "Terms and Conditions", */}
        {consent && parse(consent)}
      </div>
    </div>

  );
};

export const renderConsent = (consent) => <Consent consent={consent} />

export default Consent;
